export interface ResolveLastUpdatedByOptions {
  includeFullNameFallback?: boolean;
  fallback?: string;
}

export function resolveLastUpdatedBy(options: ResolveLastUpdatedByOptions = {}): string {
  const includeFullNameFallback = options.includeFullNameFallback ?? false;
  const fallback = options.fallback ?? 'SiteAdminUI';

  try {
    const oktaTokenStorage = localStorage.getItem('okta-token-storage');
    if (!oktaTokenStorage) {
      return fallback;
    }

    const tokenJson = JSON.parse(oktaTokenStorage);
    const claims = tokenJson?.idToken?.claims;

    const preferredUsername = String(claims?.preferred_username ?? '').trim();
    if (preferredUsername) {
      return preferredUsername;
    }

    if (includeFullNameFallback) {
      const firstName = String(claims?.given_name ?? '').trim();
      const lastName = String(claims?.family_name ?? '').trim();
      const fullName = `${firstName} ${lastName}`.trim();
      if (fullName) {
        return fullName;
      }
    }
  } catch {
  }

  return fallback;
}